// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"cba79586","71":"ddf31090","164":"38a94264","165":"743f0773","677":"3a64c11d","747":"7085db9b","763":"371befce","787":"84a8efe8","791":"91830fbc","889":"0b32f2b4"}[chunkId] + ".chunk.js";
};